import { unit } from 'mathjs';

export const ORGANIZATION_SHORT_DESCRIPTION_HELP_TEXT =
  'This is a one to two sentence overview of your business which is displayed during requests.';

export const ORGANIZATION_DETAILED_DESCRIPTION_HELP_TEXT =
  'This is your business’s profile page which will be viewable when you non-anonymously connect with another party.';

export const ORGANIZATION_HIDDEN_IDENTITY_DESCRIPTION_HELP_TEXT =
  'This is the short overview of your business which is shared when you are hiding your identity and speaking with another party.';

export const ARCHIVE_TOOLTIP =
  'Archives the current request.\nData providers will no longer be able\nto respond once this has been done.';

export const ARCHIVE_SELECTED_TOOLTIP =
  'Archives the selected requests.\nData providers will no longer be able\nto respond once this has been done.';

export const RESPOND_PROVIDERS_WARNING =
  'Please respond to all data providers before archiving a request.';

export enum FEATURE_FLAGS {
  DATA_PRODUCTS = 'data_products',
  // Feature flag for data provider file library
  DATA_FILE = 'data_file',
  DATA_BUYER_FILE_LIBRARY = 'data_buyer_file_library',
  PROPOSAL_FILE_ATTACHMENTS = 'proposal_file_attachments',
  REVIEWER_ASSIGNMENT = 'reviewer_assignment',
  AI_THREAD = 'ai_thread',
  CHECK_REQUEST_DESCRIPTION = 'check_request_description',
  CHECK_DATA_PRODUCT_DESCRIPTION = 'check_dataproduct_description',
  CHECK_SELLER_RESPONSE = 'check_seller_response',
  DISPLAY_DATA_BUYER_MY_TEAM_PAGE = 'display_data_buyer_my_team_page',
  BULK_DRM_UPLOAD = 'bulk_drm_upload',
  FREE_CONNECT = 'free_connect',
  advanced_filters = 'advanced_filters',
  SELLER_SEARCH_DETAILS = 'seller_search_details',
  UPSELL_CONNECT_USER_SUBSCRIPTIONS = 'upsell_connect_user_subscriptions',
  INVITE_COLLEAGUE_WITH_LICENSE = 'invite-colleague-with-license',
}

export const PROVIDER_RESPONSE_PROPOSAL_ERROR_CONTACT_INFO =
  'Contact info should not be entered at this stage.';

export const PROVIDER_RESPONSE_PROPOSAL_EMPTY_ERROR =
  'You must provide an answer to the question above before submitting.';

// Key to store create search progress in localStorage
export const SEARCH_PROGRESS_KEY = 'new-search';
// Key to store data provider proposal response progress in localStorage
export const PROVIDER_PROPOSAL_RESPONSE_KEY = 'provider-proposal-response-key';

export const CREATE_SEARCH_DESCRIPTION_LIMIT = 700;

export const MOBILE_VIEWPORT = 992;

// Standard maximum amount of records per page from the API call
export const PAGE_SIZE = 15;

// Date formats for moment.js library
export const DATE_FORMAT = {
  SHORT: 'MM/DD/YYYY',
  LONG: 'MM/DD/YYYY h:mm A',
  STANDARD: 'YYYY-MM-DD',
  STANDARD_TIME: 'YYYY-MM-DDTHH:mmZ',
  MUI_DATE_TIME_PICKER: 'MM/DD/YYYY hh:mm A',
};

export const AI_SEARCH_POLL_INTERVAL = unit('5s').toNumber('ms');
export const AI_CONVERSATION_MESSAGES_LIMIT = 8;
export const FILE_POLL_INTERVAL = unit('5s').toNumber('ms');
export const AI_SEARCH_MESSAGES_PAGE_SIZE = 100;
export const MAX_TIME_WAITING_CONVERSATION =
  unit('2 minutes').toNumber('seconds');

export const WAITING_MESSAGE =
  'Please wait for your other chat to complete before sending a new message.';
export const REACHED_LIMIT_MESSAGE =
  'Your chat has reached its maximum length.';

export const MAX_EMAIL_INVITATIONS_PER_ORGANIZATION = 10;
export const MAX_EMAIL_INVITATIONS_PER_SUBMIT = 10;
export const BIG_PAGE_SIZE = 100;
